export default "__VITE_ASSET__Cc9PZKyH__"